module.exports = __webpack_public_path__ + "img/section-rights.8bfcb6c2.png";